import Vue from "vue";

import BaseDialog from "@/components/Dialogs/Base";
let BaseDialogComponent = null;

import DefaultContentComponent from "@/components/Dialogs/MaterialDialog";
import ConfirmContentComponent from "@/components/Dialogs/MaterialPrompt";

export default {
  beforeDestroy: function () {
    if (!this._dialogs) return;

    for (const dialog of this._dialogs) {
      dialog.$destroy();
    }

    delete this._dialogs;
  },

  methods: {
    $dialog(props = {}, ContentComponent = DefaultContentComponent) {
      const self = this;
      let resolved = false;

      // Options
      const def = props.default;
      const keepOpenOnInput = props.keepOpenOnInput || false;

      // Defered promise
      let resolve, reject;
      const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = (val) => (def === undefined ? _reject(val) : _resolve(def));
      });

      // Lazy load BaseDialog once required
      if (!BaseDialogComponent) {
        BaseDialogComponent = Vue.extend(BaseDialog);
      }

      // Set _dialogs if not yet set
      if (!this._dialogs) {
        this._dialogs = [];
      }

      const dialog = new BaseDialogComponent({
        el: document.createElement("div"),
        store: this.$store,
        propsData: Object.assign({}, props, {
          appendToBody: true,
          visible: true,
          componentProps: props,
          component: ContentComponent,
        }),
        destroyed: () => {
          if (!resolved) {
            reject(new Error("Dialog destroyed"));
          }

          if (self._dialogs && self._dialogs.length) {
            self._dialogs = self._dialogs.filter((d) => d != dialog);
          }
        },
        mounted() {
          self._dialogs.push(this);
        },
      });

      dialog.$on("answer", (val) => {
        if (!resolved) {
          resolved = true;
          resolve(val);
        }

        if (!keepOpenOnInput) {
          dialog.visible = false;
        }
      });

      // Once a close event is received, make it invisible and start destroying
      dialog.$on("close", () => {
        if (!resolved) {
          resolved = true;
          reject(new Error("Dialog closed"));
        }

        dialog.visible = false;
      });

      // After component finishes animating closing, emit events and
      // destroy what is needed
      dialog.$on("closed", () => {
        dialog.$destroy();
      });

      // Add method to force closing
      promise.close = () => {
        dialog.visible = false;
      };

      return promise;
    },

    $confirmDialog(props = {}) {
      return this.$dialog(props, ConfirmContentComponent);
    },

    $dialogRemove(props = {}) {
      return this.$dialog(
        Object.assign(
          {
            buttons: [
              { name: "Cancelar", class: "grey--text" },
              { name: "Remover", action: true, class: "red--text" },
            ],
          },
          props,
        ),
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/helpers/VueDialog.js